import { render, staticRenderFns } from "./SaleInvoiceCollectList.vue?vue&type=template&id=187dfdf5&scoped=true&"
import script from "./SaleInvoiceCollectList.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceCollectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187dfdf5",
  null
  
)

export default component.exports